export default __webpack_public_path__ + "static/media/shared_left_bottom.10817357.png";